import styled from "@emotion/styled";
import {Spacing} from "../styles/spacing";
import {Typography} from "../styles/typography";
import * as React from "react";
import {eerieBlack} from "../styles/colors";
import {cssOnlyMobile} from "../styles/utils";

export const ValueCardContainer = styled.div`
  .valueCard:not(:last-child) {
    margin-right: 32px
  }
`

const StyledValueCard = styled.div`
  background: ${eerieBlack['0']};
  border-radius: 16px;
  padding: 32px;
`

export const ValueCard = ({icon, title, content, useCol = true}) => {
  if (useCol) {
    return (
      <div className={`col col-12 col-md-4`}>
        <StyledValueCard className={'valueCard'} css={[cssOnlyMobile('margin-bottom: 24px')]}>
          <img src={icon} alt="" css={[Spacing.Margin.bottom_16]}/>
          <h6 css={[Typography.heading.h6_700]}>{title}</h6>
          <h6 css={[Typography.heading.h6_400]}>{content}</h6>
        </StyledValueCard>
      </div>
    )
  }

  return (
    <StyledValueCard className={'valueCard'} css={[cssOnlyMobile('margin-bottom: 24px')]}>
      <img src={icon} alt="" css={[Spacing.Margin.bottom_16]}/>
      <h6 css={[Typography.heading.h6_700]}>{title}</h6>
      <h6 css={[Typography.heading.h6_400]}>{content}</h6>
    </StyledValueCard>
  )
}
